import React from 'react';
// import logo from './logo.svg';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import PasswordReset from "./PasswordReset";
import App from "./App";
import { auth, firestore } from './firebase';
import './Landing.css';



class Landing extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

    componentDidMount() {
    auth.onAuthStateChanged(async userAuth => {
      if (userAuth) {
        let user = await this.generateUserDocument(userAuth.uid);
        if (!user) {
          user = await this.getUserDocument(userAuth.uid);
        }
        this.setState({user: {uid: userAuth.uid}})
      } else {
        this.setState({user: null})
      }
    });
    
  }

  async generateUserDocument(uid, additionalData) {
      let tree = {  rootId: 1, 
                  maxId: 2,
                  startFocusId: 1,
                  taskLists: {0: {id: 0, name: "", taskOrder: []}, 1: {id: 1, name: "Tasks", taskOrder: []}},
                  taskListOrder: [1],
                  maxTaskListId: 2, 
                  completedTasks: [],
                  1: {id: 1, t: null, kids: [2], parentId: null, expand: true},
                  2: {id: 2, t: 'My first note...', kids: [], parentId: 1, expand: true},    
                };


    if (!uid) return;
    const userRef = firestore.doc(`users/${uid}`);
    const snapshot = await userRef.get();
    if (!snapshot.exists) {
      try {
        await userRef.set({
          tree,
          version: 2,
          ...additionalData
        });
        return null;
      } catch (error) {
        console.error("Error creating user document", error);
      }
    } else {
      return snapshot;
    }
  }

  async getUserDocument(uid) {


    if (!uid) return null;
    try {
      const userDocument = await firestore.doc(`users/${uid}`).get();
      return {
        uid,
        ...userDocument.data()
      };
    } catch (error) {
      console.error("Error fetching user", error);
    }
  }



  render() {

    return  <Switch>
              <Route path="/signup"> {this.state.user ?  <Redirect to="/" /> : <SignUp /> } </Route>
              <Route path="/signin">{this.state.user ?  <Redirect to="/" /> : <SignIn /> }</Route>
              <Route path="/passwordreset"><SignUp /></Route>
              <Route path="/demo"> <App demo={true} /> </Route>
              <Route path="/" >{this.state.user ?  <App demo={false} user={this.state.user} /> : 
              <div className="LandingPage">
                <h6>Prototype App</h6>
                <a href="/signup">Sign Up</a>
                <br />
                <a href="/signin">Sign In</a>

              </div>

            }
               

              </Route>
            </Switch>



    

      

  }


}


export default Landing;
